module.exports = __webpack_public_path__ + "static/feature-phone-mobile-4-193555614b8692e8b2e5652d9a04e2d5.png";